export const PAGE_PERFORMANCE_CATEGORY = {
    PERFORMANCE: 'performance',
    BEST_PRACTICE: 'best-practices',
    SEO: 'seo',
    PWA: 'pwa',
} as const;
